
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fB9FN", function(module, exports) {
/* CreateFromTemplate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $cO1el = parcelRequire("cO1el");


var $inPa6 = parcelRequire("inPa6");


var $kDja4 = parcelRequire("kDja4");


var $1NBp8 = parcelRequire("1NBp8");

/* StaticNudge.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $b70ec7a3966600a1$export$1fa5a43af950a186 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "29",
        viewBox: "0 0 20 29",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.62532 28.0042C1.41951 27.963 1.24756 27.8305 1.16387 27.6484L0.0538692 25.2342C-0.0889378 24.9236 0.0622921 24.5627 0.391649 24.428C0.721006 24.2933 1.10377 24.436 1.24658 24.7466L1.3977 25.0752C1.99248 21.6332 2.78636 18.1182 4.64414 15.0135C6.13141 12.528 8.47823 10.3022 11.2754 9.14168C10.7924 7.94344 10.649 6.62427 10.9235 5.36484C11.4961 2.72829 13.8266 0.541103 16.6223 0.0117302C16.9742 -0.0549145 17.3168 0.160131 17.3875 0.492044C17.4582 0.823959 17.2301 1.14705 16.8782 1.2137C14.5941 1.6462 12.6646 3.45729 12.197 5.61119L12.1969 5.61166C11.9727 6.64044 12.0941 7.7266 12.4937 8.71386C13.5197 8.41783 14.5943 8.26779 15.6996 8.29879L15.7001 8.29881C16.4395 8.3201 17.2694 8.4994 17.9469 8.8689C18.6285 9.24068 19.2307 9.8543 19.2889 10.7401C19.3758 12.0185 18.1956 12.9865 17.0522 13.1743C15.9031 13.3646 14.7888 12.9202 13.9564 12.3901L13.9556 12.3895C13.0888 11.8357 12.372 11.0948 11.8406 10.2486C9.34031 11.2722 7.17657 13.276 5.77631 15.616C3.93084 18.7001 3.18811 22.2433 2.58125 25.8598L3.31024 25.2276C3.57448 24.9985 3.98568 25.0147 4.22867 25.2639C4.47167 25.5131 4.45445 25.9009 4.19021 26.13L2.20021 27.8558C2.04534 27.9901 1.83113 28.0454 1.62532 28.0042ZM13.0932 9.82771C13.5119 10.4362 14.0497 10.9687 14.6845 11.3744C15.3919 11.8248 16.1571 12.078 16.8277 11.9668L16.8289 11.9666C17.525 11.8524 18.0241 11.2933 17.9916 10.8182L17.9914 10.8164C17.9693 10.4768 17.7467 10.1759 17.296 9.93015C16.841 9.68198 16.2311 9.54064 15.6605 9.52419M13.0932 9.82771C13.9262 9.60797 14.7866 9.49973 15.6604 9.52419L13.0932 9.82771Z",
        fill: "currentColor"
    }));





const $a782d1662e81c4c8$export$2624c5890f1bbcf7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "29",
        viewBox: "0 0 20 29",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.62483 0.0133558C1.41902 0.0545344 1.24708 0.187107 1.16338 0.369139L0.053381 2.78333C-0.089426 3.09393 0.0618038 3.45489 0.391161 3.58957C0.720518 3.72424 1.10328 3.58163 1.24609 3.27103L1.39721 2.94235C1.99199 6.38436 2.78587 9.89942 4.64365 13.0041C6.13092 15.4895 8.47775 17.7154 11.2749 18.8759C10.7919 20.0741 10.6486 21.3933 10.923 22.6527C11.4956 25.2893 13.8261 27.4765 16.6218 28.0058C16.9737 28.0725 17.3163 27.8574 17.387 27.5255C17.4577 27.1936 17.2297 26.8705 16.8777 26.8039C14.5936 26.3714 12.6641 24.5603 12.1965 22.4064L12.1964 22.4059C11.9722 21.3771 12.0936 20.291 12.4932 19.3037C13.5192 19.5998 14.5938 19.7498 15.6991 19.7188L15.6996 19.7188C16.439 19.6975 17.2689 19.5182 17.9464 19.1487C18.628 18.7769 19.2302 18.1633 19.2884 17.2774C19.3753 15.9991 18.1951 15.031 17.0517 14.8433C15.9027 14.6529 14.7883 15.0974 13.956 15.6275L13.9551 15.628C13.0883 16.1819 12.3716 16.9228 11.8402 17.7689C9.33982 16.7453 7.17608 14.7416 5.77582 12.4016C3.93036 9.31749 3.18762 5.77427 2.58076 2.15776L3.30975 2.78996C3.57399 3.01911 3.98519 3.00287 4.22819 2.75368C4.47118 2.50449 4.45396 2.11671 4.18972 1.88756L2.19972 0.161786C2.04485 0.0274855 1.83064 -0.0278229 1.62483 0.0133558ZM13.0927 18.1899C13.5115 17.5814 14.0492 17.0488 14.6841 16.6431C15.3914 16.1928 16.1566 15.9396 16.8272 16.0508L16.8284 16.051C17.5245 16.1652 18.0236 16.7243 17.9911 17.1994L17.991 17.2012C17.9688 17.5408 17.7462 17.8416 17.2956 18.0874C16.8406 18.3356 16.2306 18.4769 15.66 18.4934M13.0927 18.1899C13.9257 18.4096 14.7861 18.5178 15.6599 18.4934L13.0927 18.1899Z",
        fill: "currentColor"
    }));


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb71264bbc9c224a$var$ArrowContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0pxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $bb71264bbc9c224a$var$StaticNudgeContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _ae4v1h6o",
            __cmplp.className
        ])
    });
});
const $bb71264bbc9c224a$var$TextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $bb71264bbc9c224a$export$b8314ae60a176077 = ({ position: position, text: text, customStyles: customStyles })=>{
    const Arrow = position === 'up' ? (0, $a782d1662e81c4c8$export$2624c5890f1bbcf7) : (0, $b70ec7a3966600a1$export$1fa5a43af950a186);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb71264bbc9c224a$var$StaticNudgeContainer, {
        style: {
            ...customStyles
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb71264bbc9c224a$var$ArrowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Arrow, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb71264bbc9c224a$var$TextContainer, null, text)));
};



var $i1Y90 = parcelRequire("i1Y90");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

/* TemplatesList.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $iXCQx = parcelRequire("iXCQx");

var $d4b45fc4b1085e66$exports = {};
$d4b45fc4b1085e66$exports = new URL("FireIcon.c84e0a2e.svg", import.meta.url).toString();



var $jYZYm = parcelRequire("jYZYm");

/**
 * @generated SignedSource<<81f22894ce74605451be58ab958e6b3e>>
 * @relayHash 7332ebf6c44dc80945d33164086421e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8bd7af0e34b4068f7b5937012a6fa01e09d1234a930d63666730d898dc7dd3c1
const $08808f1a47ecd134$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "blueprintKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "blueprintKey"
                }
            ],
            "concreteType": "TemplateInfo",
            "kind": "LinkedField",
            "name": "templateInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconURL"
                },
                {
                    "kind": "ScalarField",
                    "name": "darkModeIconURL"
                },
                {
                    "kind": "ScalarField",
                    "name": "templateType"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentBlueprintId"
                },
                {
                    "kind": "ScalarField",
                    "name": "blueprintModuleCompleteKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "itemModuleCompleteKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TemplateCardHomeViewGetTemplateInfoQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TemplateCardHomeViewGetTemplateInfoQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7332ebf6c44dc80945d33164086421e8",
            "id": "8bd7af0e34b4068f7b5937012a6fa01e09d1234a930d63666730d898dc7dd3c1",
            "metadata": {},
            "name": "TemplateCardHomeViewGetTemplateInfoQuery",
            "operationKind": "query",
            "text": "query TemplateCardHomeViewGetTemplateInfoQuery($blueprintKey:ID!){templateInfo(id:$blueprintKey){name,iconURL,darkModeIconURL,templateType,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey}}"
        }
    };
}();
$08808f1a47ecd134$var$node.hash = "ec91cd9c58827fd518e9de2ec8ef39cf";
var $08808f1a47ecd134$export$2e2bcd8739ae039 = $08808f1a47ecd134$var$node;















var $fpGTa = parcelRequire("fpGTa");

var $ecnYn = parcelRequire("ecnYn");


var $7aRa9 = parcelRequire("7aRa9");










var $2YJkl = parcelRequire("2YJkl");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $bZSO8 = parcelRequire("bZSO8");


var $jhwJP = parcelRequire("jhwJP");


var $e4o8D = parcelRequire("e4o8D");


var $b3j2Y = parcelRequire("b3j2Y");


var $jMyy4 = parcelRequire("jMyy4");

/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $3wBuN = parcelRequire("3wBuN");

var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e2ff2d4fee702fd$var$IconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1ul9 _4t3i1ul9",
            __cmplp.className
        ])
    });
});
const $4e2ff2d4fee702fd$export$17f8b5fdc0dde895 = ({ iconURL: iconURL, darkModeIconURL: darkModeIconURL })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e2ff2d4fee702fd$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: iconURL || '',
        srcDark: darkModeIconURL || ''
    }))));
};








const $6aacecfbfc9d30df$export$c269f1e612e6b6ab = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendCreateFromTemplateAnalyticsEvent = (0, $42omo.useCallback)(({ type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        createAnalyticsEvent({
            type: type,
            data: {
                source: 'homeOnboarding',
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return sendCreateFromTemplateAnalyticsEvent;
};


var $ce1ab02f75cb72a3$exports = {};
$ce1ab02f75cb72a3$exports = new URL("WhiteboardsIcon.0d940942.svg", import.meta.url).toString();


const $909f2dc28fabfb60$var$i18nBase = (0, $aXWIB.defineMessages)({
    secondary: {
        id: "home.views.create-from-templates.template-card.secondary",
        defaultMessage: "Template"
    },
    whiteboardSecondary: {
        id: "home.views.create-from-templates.whiteboard-card.secondary",
        defaultMessage: "Choose a template"
    },
    whiteboardPrimary: {
        id: "home.views.create-from-templates.whiteboard-card.primary",
        defaultMessage: "Create a whiteboard"
    },
    errorTitle: {
        id: "home.views.create-from-templates.template-card.error-title",
        defaultMessage: "We can\u2019t create a page for you"
    },
    errorDescription: {
        id: "home.views.create-from-templates.template-card.error-description",
        defaultMessage: "Refresh and try again. If this keeps happening, contact Support."
    }
});
const $909f2dc28fabfb60$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "home.views.create-from-templates.template-card.error-title.livedocs",
        defaultMessage: "We can\u2019t create a page or live doc for you"
    }
});
const $909f2dc28fabfb60$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($909f2dc28fabfb60$var$i18nBase, $909f2dc28fabfb60$var$i18nLiveDocs); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $909f2dc28fabfb60$var$Card = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko1mok _1yt4pxbi _kqswh2mm _80omtlke _bfhkvuon _1dbzt7xp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $909f2dc28fabfb60$var$ContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $909f2dc28fabfb60$var$Header = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $909f2dc28fabfb60$var$CardIcon = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx12x7",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$CardPrimarySecondary = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$CardPrimary = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81qyo _syazi7uo _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$CardSecondary = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _43dsazsu _1cayazsu _oxk4azsu",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$CardPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _1e0c1txw _4t3i3okq _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$ContentPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$IconPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1bsb1tcg _4t3i1tcg _19pkv77o _2hwxpxbi _bfhkizff",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$TitleAndTypePlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _1bah1yb4 _1ul9uuw1 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$TitlePlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3i1crf _1bsb19wn _bfhkizff _otyrv77o",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$TypePlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3i1crf _1bsbx19p _bfhkizff",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$DescriptionPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _4t3i1crf _1bsb1nrf _bfhkizff",
            __cmplp.className
        ])
    });
});
const $909f2dc28fabfb60$var$whiteboardContainerStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    textDecoration: 'none !important'
});
const $909f2dc28fabfb60$var$whiteboardListStyle = null;
const $909f2dc28fabfb60$var$templateListStyle = null;
const $909f2dc28fabfb60$var$reportError = (experienceTracker, error, attributes)=>{
    (0, $7Sm4c.markErrorAsHandled)(error);
    experienceTracker.fail({
        name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_CREATE_TEMPLATE_EXPERIENCE),
        error: error,
        attributes: attributes
    });
};
const $909f2dc28fabfb60$var$CardComponent = ({ onClick: onClick, data: data, secondaryMessage: secondaryMessage, secondary: secondary, loading: loading })=>{
    const { name: name, iconURL: iconURL, darkModeIconURL: darkModeIconURL } = data ?? {};
    return !loading && data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$Card, {
        "data-testid": "template-card",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardIcon, {
        "data-testid": "template-card-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e2ff2d4fee702fd$export$17f8b5fdc0dde895), {
        iconURL: iconURL || '',
        darkModeIconURL: darkModeIconURL || ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardPrimarySecondary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardPrimary, null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardSecondary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardSecondary, null, secondary))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardPlaceholder, {
        "data-testid": "template-card-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$ContentPlaceholder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$IconPlaceholder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$TitleAndTypePlaceholder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$TitlePlaceholder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$TypePlaceholder, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$DescriptionPlaceholder, null));
};
const $909f2dc28fabfb60$export$ba340e850b866867 = (0, $7aRa9.withFlags)(({ secondary: secondary, templateKey: templateKey, personalSpaceKey: personalSpaceKey, onRenderingDone: onRenderingDone, flags: flags, teamTypeLoading: teamTypeLoading })=>{
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $08808f1a47ecd134$export$2e2bcd8739ae039), {
        variables: {
            blueprintKey: templateKey
        },
        onCompleted: ()=>{
            onRenderingDone();
        },
        onError: (error)=>{
            $909f2dc28fabfb60$var$reportError(experienceTracker, error, {
                blueprintKey: templateKey
            });
        // Here we don't show a flag, because the user has not yet taken any action.
        },
        skip: teamTypeLoading
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const createFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const sendCreateFromTemplateAnalyticsEvent = (0, $6aacecfbfc9d30df$export$c269f1e612e6b6ab)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const handleOnClick = async ()=>{
        const template = data?.templateInfo;
        if (!template) return;
        const handleCreationError = (error)=>{
            $909f2dc28fabfb60$var$reportError(experienceTracker, error, {
                blueprintKey: templateKey
            });
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $909f2dc28fabfb60$var$i18n.errorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $909f2dc28fabfb60$var$i18n.errorDescription)
            });
        };
        sendCreateFromTemplateAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'component',
            actionSubjectId: 'createPageFromTemplate',
            attributes: {
                templateKey: template.blueprintModuleCompleteKey,
                spaceKey: personalSpaceKey
            }
        });
        const createOptions = {
            onVariableInputError: handleCreationError,
            forceTemplatePanelOpen: true
        };
        try {
            await createFromTemplate(template, personalSpaceKey, createOptions);
            experienceTracker.succeed({
                name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_CREATE_TEMPLATE_EXPERIENCE)
            });
            setOnboardingState({
                key: (0, $dBcar.TEMPLATES_COLLECTION).EXPERIMENT_DISMISSED,
                value: 'true'
            });
        } catch (err) {
            handleCreationError(err);
        }
    };
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    if (!renderServerPlaceholder && !loading && !teamTypeLoading && !data?.templateInfo) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_CREATE_TEMPLATE_EXPERIENCE),
        attributes: {
            blueprintKey: templateKey
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardComponent, {
        onClick: handleOnClick,
        loading: loading,
        data: data?.templateInfo,
        secondary: secondary,
        secondaryMessage: $909f2dc28fabfb60$var$i18n.secondary
    })));
});
const $909f2dc28fabfb60$export$7d7d45f47251c1d3 = ({ secondary: secondary, templateKey: templateKey, personalSpaceKey: personalSpaceKey, teamTypeLoading: teamTypeLoading })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendCreateFromTemplateAnalyticsEvent = (0, $6aacecfbfc9d30df$export$c269f1e612e6b6ab)();
    const SCREEN_NAME = 'homeScreenCreateFromTemplate';
    const createWhiteboardHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'whiteboard',
        source: SCREEN_NAME,
        withFallback: true,
        spaceKey: personalSpaceKey
    });
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'whiteboardCard',
                source: 'homeOnboarding'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        sendCreateFromTemplateAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'component',
            actionSubjectId: 'whiteboardCard',
            attributes: {
                templateKey: templateKey,
                spaceKey: personalSpaceKey
            }
        });
        experienceTracker.succeed({
            name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_CREATE_TEMPLATE_EXPERIENCE)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_CREATE_TEMPLATE_EXPERIENCE),
        attributes: {
            blueprintKey: templateKey
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        xcss: $909f2dc28fabfb60$var$whiteboardContainerStyle,
        href: createWhiteboardHref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($909f2dc28fabfb60$var$CardComponent, {
        data: {
            name: intl.formatMessage($909f2dc28fabfb60$var$i18n.whiteboardPrimary),
            iconURL: (0, (/*@__PURE__*/$parcel$interopDefault($ce1ab02f75cb72a3$exports))),
            darkModeIconURL: (0, (/*@__PURE__*/$parcel$interopDefault($ce1ab02f75cb72a3$exports)))
        },
        secondaryMessage: $909f2dc28fabfb60$var$i18n.whiteboardSecondary,
        secondary: secondary,
        onClick: onClick,
        loading: teamTypeLoading
    }))));
};


const $ecebcaccfd9bf7e5$var$WHITEBOARD = 'whiteboard';
const $ecebcaccfd9bf7e5$var$i18n = (0, $aXWIB.defineMessages)({
    popularFor: {
        id: "home.views.create-from-templates.templates-list.popular-for",
        defaultMessage: "Popular for {teamType}"
    },
    popular: {
        id: "home.views.create-from-templates.templates-list.popular",
        defaultMessage: "Popular"
    },
    recommendedFor: {
        id: "home.views.create-from-templates.templates-list.recommended-for",
        defaultMessage: "Recommended for {teamType}"
    },
    recommended: {
        id: "home.views.create-from-templates.templates-list.recommended",
        defaultMessage: "Recommended"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ecebcaccfd9bf7e5$var$GridContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowRightPanel: shouldShowRightPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulppxbi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c11p5 _2z051e96 _otyrpxbi _2mzuglyw _19bvidpf",
            !__cmplp.shouldShowRightPanel ? "_yv0e13pt" : "_yv0e9sye",
            __cmplp.className
        ])
    });
});
const $ecebcaccfd9bf7e5$var$SecondaryContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ecebcaccfd9bf7e5$var$EmojiContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ecebcaccfd9bf7e5$export$b768bbdb9877477 = ({ teamType: teamType, teamTypeLoading: teamTypeLoading, templateKeys: templateKeys, personalSpaceKey: personalSpaceKey, onRenderingDone: onRenderingDone })=>{
    const { shouldShowRightPanel: shouldShowRightPanel } = (0, $jYZYm.useRightPanelVisible)();
    const determineSecondary = (first, teamType)=>{
        if (first) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecebcaccfd9bf7e5$var$SecondaryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecebcaccfd9bf7e5$var$EmojiContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d4b45fc4b1085e66$exports))),
            alt: ""
        })), teamType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$ecebcaccfd9bf7e5$var$i18n.popularFor,
            values: {
                teamType: teamType
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ecebcaccfd9bf7e5$var$i18n.popular));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecebcaccfd9bf7e5$var$SecondaryContainer, null, teamType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$ecebcaccfd9bf7e5$var$i18n.recommendedFor,
            values: {
                teamType: teamType
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ecebcaccfd9bf7e5$var$i18n.recommended));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecebcaccfd9bf7e5$var$GridContainer, {
        shouldShowRightPanel: shouldShowRightPanel
    }, templateKeys.map((templateKey, idx)=>{
        const secondary = determineSecondary(idx === 0, teamType);
        const Card = templateKey === $ecebcaccfd9bf7e5$var$WHITEBOARD ? (0, $909f2dc28fabfb60$export$7d7d45f47251c1d3) : (0, $909f2dc28fabfb60$export$ba340e850b866867);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Card, {
            key: templateKey,
            templateKey: templateKey,
            teamTypeLoading: teamTypeLoading,
            secondary: secondary,
            personalSpaceKey: personalSpaceKey,
            onRenderingDone: onRenderingDone
        });
    }));
};


const $1d2071b639496264$var$CUSTOMER_SUPPORT = 'Customer Support';
// Jira team page uses customer service while confluence team page uses customer support
const $1d2071b639496264$var$CUSTOMER_SERVICE = 'Customer Service';
const $1d2071b639496264$var$IT_SUPPORT = 'IT Support';
const $1d2071b639496264$var$FINANCE = 'Finance';
const $1d2071b639496264$var$HUMAN_RESOURCES = 'Human Resources';
const $1d2071b639496264$var$LEGAL = 'Legal';
const $1d2071b639496264$var$MARKETING = 'Marketing';
const $1d2071b639496264$var$OPERATIONS = 'Operations';
const $1d2071b639496264$var$SALES = 'Sales';
const $1d2071b639496264$var$SOFTWARE_DEVELOPMENT = 'Software Development';
const $1d2071b639496264$var$DESIGN = 'Design';
const $1d2071b639496264$var$RESEARCH = 'Research';
const $1d2071b639496264$var$PRODUCT_MANAGEMENT = 'Product Management';
const $1d2071b639496264$var$PROJECT_MANAGEMENT = 'Project Management';
const $1d2071b639496264$var$WHITEBOARD = 'whiteboard';
const $1d2071b639496264$export$80fc3d5e97d9af57 = (teamType, hasWhiteboard)=>{
    let templates;
    switch(teamType){
        case $1d2071b639496264$var$CUSTOMER_SUPPORT:
        case $1d2071b639496264$var$CUSTOMER_SERVICE:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint'
            ];
            break;
        case $1d2071b639496264$var$IT_SUPPORT:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint'
            ];
            break;
        case $1d2071b639496264$var$FINANCE:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint'
            ];
            break;
        case $1d2071b639496264$var$HUMAN_RESOURCES:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint'
            ];
            break;
        case $1d2071b639496264$var$LEGAL:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint'
            ];
            break;
        case $1d2071b639496264$var$MARKETING:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint'
            ];
            break;
        case $1d2071b639496264$var$OPERATIONS:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint'
            ];
            break;
        case $1d2071b639496264$var$SALES:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint'
            ];
            break;
        case $1d2071b639496264$var$SOFTWARE_DEVELOPMENT:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:4-ls-retrospective-blueprint'
            ];
            break;
        case $1d2071b639496264$var$DESIGN:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint'
            ];
            break;
        case $1d2071b639496264$var$RESEARCH:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint'
            ];
            break;
        case $1d2071b639496264$var$PROJECT_MANAGEMENT:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint'
            ];
            break;
        case $1d2071b639496264$var$PRODUCT_MANAGEMENT:
            templates = [
                'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:productlaunch-blueprint'
            ];
            break;
        default:
            templates = [
                'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
                'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint'
            ];
    }
    if (hasWhiteboard) templates[2] = $1d2071b639496264$var$WHITEBOARD;
    return templates;
};



const $b1498991ba429335$var$i18n = (0, $aXWIB.defineMessages)({
    header: {
        id: "home.views.create-from-templates.header",
        defaultMessage: "Create from a template"
    },
    viewAll: {
        id: "home.views.create-from-templates.view-all",
        defaultMessage: "View all"
    },
    defaultGuideArrowText: {
        id: "home.views.create-from-templates.guide-arrow-text",
        defaultMessage: "These templates are popular with people getting started on Confluence"
    },
    guideArrowTextForSpecificTeam: {
        id: "home.views.create-from-templates.guide-arrow-text-for-specific-team",
        defaultMessage: "These templates are popular with people who do work similar to yours."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1498991ba429335$var$Header = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $b1498991ba429335$var$ArrowPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1u1b",
            __cmplp.className
        ])
    });
});
const $b1498991ba429335$export$ad119032dc8f4054 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
})(()=>{
    const { shouldShowGuidingArrow: shouldShowGuidingArrow, teamType: teamType, personalSpaceKey: personalSpaceKey, teamTypeLoading: teamTypeLoading, teamTypeError: teamTypeError } = (0, $i1Y90.useTemplatesCollectionEligible)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteBoardEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const guideArrowText = teamType ? $b1498991ba429335$var$i18n.guideArrowTextForSpecificTeam : $b1498991ba429335$var$i18n.defaultGuideArrowText;
    const templateKeys = (0, $1d2071b639496264$export$80fc3d5e97d9af57)(teamType ?? undefined, isWhiteBoardEnabled);
    const [hasTemplatesRendered, setHasTemplatesRendered] = (0, $42omo.useState)(false);
    const onRenderingDone = ()=>setHasTemplatesRendered(true);
    const sendCreateFromTemplateAnalyticsEvent = (0, $6aacecfbfc9d30df$export$c269f1e612e6b6ab)();
    const handleClick = ()=>{
        sendCreateFromTemplateAnalyticsEvent({
            type: 'sendUIEvent',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'viewAllTemplatesLink',
            attributes: {
                teamType: teamType
            }
        });
    };
    (0, $42omo.useEffect)(()=>{
        if (!teamTypeLoading) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'templatesCollection',
                    source: 'homeOnboarding',
                    attributes: {
                        teamType: teamType
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_EXPERIENCE)
            });
        }
    }, [
        createAnalyticsEvent,
        teamType,
        teamTypeLoading,
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        if (teamTypeError) experienceTracker.fail({
            name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_EXPERIENCE),
            error: teamTypeError
        });
    }, [
        experienceTracker,
        teamTypeError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ONBOARDING_TEMPLATE_COLLECTIONS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1498991ba429335$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b1498991ba429335$var$i18n.header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: String((0, $1NBp8.TEMPLATE_GALLERY).toUrl()),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b1498991ba429335$var$i18n.viewAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ecebcaccfd9bf7e5$export$b768bbdb9877477), {
        teamType: teamType ?? '',
        teamTypeLoading: teamTypeLoading,
        templateKeys: templateKeys,
        personalSpaceKey: personalSpaceKey ?? '',
        onRenderingDone: onRenderingDone
    }), shouldShowGuidingArrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasTemplatesRendered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bb71264bbc9c224a$export$b8314ae60a176077), {
        customStyles: {
            color: "var(--ds-text-accent-purple, #803FA5)",
            marginTop: "var(--ds-space-100, 8px)"
        },
        position: "up",
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), guideArrowText)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1498991ba429335$var$ArrowPlaceholder, null)));
});
module.exports["TemplateCollections"] = $b1498991ba429335$export$ad119032dc8f4054;

});


//# sourceMappingURL=CreateFromTemplate.e70b27b6.js.map
